import Vue from 'vue'
import 'vue-datetime/dist/vue-datetime.css'
import { Datetime } from 'vue-datetime'
import { Settings } from 'luxon'

Settings.defaultLocale = 'nl'
Vue.component('vue-datetime', Datetime)
